$ () ->
    window.sk_automagic = new Automagic
        username: 'sean_knutson'
        masqueradeUser: 'NuTech Rep'
        autorun: false

        steps: [
            {
                wait: 500
                when: () -> $('li a[data-handler="Placement"]').length > 0

                do: () ->
                    $('li a[data-handler="Placement"]').click()
            }

            {
                when: () -> $('#start_survey_button').length > 0

                do: () ->
                    $('#start_survey_button').click()
            }

            {
                maxWaitTime: 10000
                when: () ->
                    App.current_page.activeSubHandlers['Grower.NuTech_SPP_Handler']?

                do: () ->
                    window.spp = App.current_page.activeSubHandlers['Grower.NuTech_SPP_Handler']
                    # window.debug = true
            }

            {
                maxWaitTime: 10000
                when: () ->
                    window.spp.curStep?.num is 1

                waitAnother: 500
                do: () ->
                    $('#select_all_button').click()
                    $('#next_button').click()
            }

            {
                when: () ->
                    # console.log window.spp.curStep
                    window.spp.curStep?.num is 2

                waitAnother: 500
                do: () ->
                    $('.spp-tr>td:first-of-type .spp-clickable-cell').click()
                    $('#next_button').click()
            }

            {
                when: () ->
                    window.spp.curStep?.num is 3

                waitAnother: 500
                do: () ->
                    $('#next_button').click()
            }

            {
                when: () ->
                    window.spp.curStep?.num is 4

                waitAnother: 500
                do: () ->
                    $('#next_button').click()
            }

            {
                when: () ->
                    window.spp.curStep?.num is 5

                waitAnother: 500
                do: () ->
                    $('tr:nth-of-type(1) input[data-step="5"][type="text"]').val('100')
                    $('tr:nth-of-type(2) input[data-step="5"][type="text"]').val('110')
                    $('#next_button').click()
            }

        ]
